import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Grid,
  InputLabel,
  Switch,
  Tooltip
} from "@mui/material";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { checkForRole } from "../../utils/GetAuth";
import {
  Save,
  Help,
} from '@mui/icons-material';
import TableAbstraction from "../../componentUtils/TableAbstraction";
import { GetCategoryList } from "../../utils/GetAdmin";
import { saveThresholdConfig,protectBeverageCategoryConfig } from "../../utils/PostAdmin";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {
  },
    card: {},
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    checkbox: {
      padding: 0,
    },
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      color: "red",
      textDecoration: "underline",
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
    modalInput: {
      width: "350px",
    },
    input: {
      width:"350px"
    },
    Master:{
      paddingLeft:"10px"
    }
  })
);

export default function ProtectBeverageCategory() {
  const classes = useStyles();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const enabled = checkForRole(clientId,salesOrg,'cona_internal_dev');
  const [doneLoading, setDoneLoading] = React.useState<boolean>();  
  const [categoryList, SetCategoryList] = useState<any[]>([]);
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [isProtectCategory, setIsProtectCategory] = React.useState<boolean>(false);
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [glassFrontBevCat, setGlassFrontBevCat] = React.useState<string>("");
  const [glassFrontIndiMat, setGlassFrontIndiMat] = React.useState<string>("");
  const [stackBevCat, setStackBevCat] = React.useState<string>("");
  const [stackIndiMat, setStackIndiMat] = React.useState<string>("");
  const [isGlassFrontSet, setIsGlassFrontSet] = React.useState<boolean>(false);
  const [isStackSet, setIsStackSet] = React.useState<boolean>(false);


  useEffect(() => {
    if (doneLoading) return;
    GetCategoryList(salesOrg).then((v) => {
      setDoneLoading(true);
      if(v ) SetCategoryList(v.mappings);
      if(v.threshold_list.length>1) {
        setGlassFrontBevCat(v.threshold_list[0].beverage_category);
        setStackBevCat(v.threshold_list[1].beverage_category);
      }
      /*else{
          if(v.threshold_list[0].config_type==="GLASS") {setGlassFrontBevCat(v.threshold_list[0].beverage_category);}
          if(v.threshold_list[0].config_type==="STACK") {setStackBevCat(v.threshold_list[0].beverage_category);}
      }*/
    });
  }, [categoryList,doneLoading,salesOrg]);

  const handleBulkProtectCategory=()=>{
    const protectedCategory = categoryList.filter(obj => obj.beverage_category!==null).map(obj => obj).length;    
    const protectCat = categoryList.map(obj => obj.code);
    let code=false;
    if(protectedCategory<protectCat.length){
      code=true;
    }
    let csList = categoryList.map(a => {
      var returnValue = {...a};
      if(protectedCategory<protectCat.length){
        returnValue.beverage_category = returnValue.code;
      }else{
        returnValue.beverage_category = null;
      }
      
      return returnValue
    })
    SetCategoryList(csList);
    protectBeverageCategoryConfig(salesOrg,code,protectCat).then((ret:any) => {
      if(ret && ret.mdEquipmentModelMap){

      }
    });
  }

  const setProtectCategory=(checkeVal:any,code:any)=>{
     let csList = categoryList.map(a => {
      var returnValue = {...a};
    
      if (a.code === code) {
        if(checkeVal===true){
          returnValue.beverage_category = code;
        }else{
          returnValue.beverage_category = null;
        }
        
      }
    
      return returnValue
    })
     SetCategoryList(csList);
     code = [code];
    protectBeverageCategoryConfig(salesOrg,checkeVal,code).then((ret:any) => {
      if(ret && ret.mdEquipmentModelMap){

      }
    });
  }
  const handleModalSave=(bevCat:any,indiMat:any,type:string)=>{
    let newmapdata = {beverage_category: bevCat, indiviual_material:indiMat, config_type:type};
    saveThresholdConfig(salesOrg,newmapdata).then((ret:any) => {
      //SetCategoryList(ret.mdEquipmentModelMap);
      if(ret && ret.mdEquipmentModelMap){

      }
    });
  }
  return (      
        <div className={classes.root}>
          <div className={classes.Master}>
           <Typography variant="h6" className={classes.paragraph}>
                Threshold Configuration for the Beverage Category <Tooltip title="This configuration applies to the entire sales organization. Protected beverage categories identified here will influence the generated recommendations">
                <Help /></Tooltip>
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.paragraph}
              paragraph
            >
              <strong>GLASS FRONT(% of Sales)</strong> 
            </Typography>
            <Grid container spacing={2} className={classes.primary}>
              <Grid item xs={5} md={5} xl={5}>
                <InputLabel >Beverage Category <Tooltip title="The beverage category will be protected if the total sales percentage of materials in the same category exceeds the set percentage of glassfront machine. ">
                <Help /></Tooltip></InputLabel>
                  <TextField placeholder='Sales %' type='text'
                                      className={classes.input}
                                      value={`${glassFrontBevCat}%`}
                                      InputProps={{ 
                                        inputProps: { min: 0, max: 100 } }} 
                                      onChange={(e) => {
                                        let numericValue =e.target.value.replace(/[^0-9]/g, '');
                                        numericValue = Math.max(0, Math.min(100, parseInt(numericValue, 10) || 0)).toString(); // Limit to 0-100

                                        setGlassFrontBevCat(numericValue.replace('%', '').trim());
                                        setIsGlassFrontSet(true);
                                      }}>    
                  </TextField>
              </Grid>
            
              <div style={{ paddingRight: "5px",  textAlign:"right"}}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              handleModalSave(glassFrontBevCat,glassFrontIndiMat,'GLASS');
                              setIsGlassFrontSet(false);
                            }}
                            disabled={!isGlassFrontSet}>
                            <Save /> Save
                          </Button>
                          </div>
            
            </Grid>
            <Typography
              variant="subtitle1"
              sx={{ paddingTop: 3 }}
              className={classes.paragraph}
              paragraph
            >
              <strong>STACK(% of Sales)</strong> 
            </Typography>
            <Grid container spacing={2} className={classes.primary} style={{ marginBottom: "10px"}}>
              <Grid item xs={5} md={5} xl={5}>
                <InputLabel >Beverage Category <Tooltip title="The beverage category will be protected if the total sales percentage of materials in the same category exceeds the set percentage">
                <Help /></Tooltip></InputLabel>
                  <TextField placeholder='Sales %' type='text'
                                      className={classes.input}
                                      InputProps={{ inputProps: { min: 0, max: 100 }}} 
                                      value= {`${stackBevCat}%`}
                                      onChange={(e) => {
                                        let numericValue =e.target.value.replace(/[^0-9]/g, '');
                                        numericValue = Math.max(0, Math.min(100, parseInt(numericValue, 10) || 0)).toString(); 
                                        setStackBevCat(numericValue.replace('%', '').trim());
                                        setIsStackSet(true);
                                      }}>    
                  </TextField>
              </Grid>
              
              <div style={{ paddingRight: "5px",  textAlign:"right"}}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              handleModalSave(stackBevCat,stackIndiMat,'STACK');
                              setIsStackSet(false);
                            }}
                            disabled={!isStackSet}
                            >
                            <Save /> Save
                          </Button>
                          </div>
            
            </Grid>
          </div>
          <TableAbstraction
          settingsKey="ADM_EQM"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <React.Fragment>
              <Button  color="primary" size="small" variant="outlined" onClick={() => handleBulkProtectCategory()}>
               Select All</Button>
               </React.Fragment>
              );
            },
          }}
          title="Protect The Beverage Category"
          columns={[
            {
              label: "Beverage Category",
              name: "text",
              options: {
                searchable: true,
                filter: false,
              },
            },
           
           
            {
              label: "Beverage Category Details",
              name: "text_long",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Protect",
              name: "code",
              options: {
                filter: false,
                renderCell: (props) => {
                  const tableMeta = props.row;

                  return (
                    <React.Fragment>
                       <Switch name="beverage_category" color="error" checked={categoryList.some(function(ele) {return ele.code ===tableMeta.beverage_category}) } value={tableMeta.code} onChange={(event) => setProtectCategory(event.target.checked,tableMeta.code)}/>
                    </React.Fragment>
                  );
                },
              },
            },
          ]}
          data={categoryList}
        />
        </div>

    )
}